exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".value-check-modal .group-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n.value-check-modal .group-row .row-title {\n  width: 150px;\n  margin-top: 8px;\n}\n.value-check-modal .group-row .row-content {\n  width: 100%;\n}\n.value-check-modal .group-row .row-content .text-response__wrap {\n  border: 1px solid #D7D7DE;\n  border-radius: 6px;\n}\n", ""]);

// exports
